import { createFileRoute, Outlet } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";

import { authenticate } from "@/app/lib/api/api";
import { CommonTrackingEvents, rudderAnalytics } from "@/app/lib/rudderstack";
import { decode } from "@/app/lib/utils/tokens";
import { BannersPlacementSlug } from "@/app/lib/types/enums";
import { bannersPlacementQueryOptions } from "@/app/lib/hooks/useBannersPlacement";

export const Route = createFileRoute("/_authenticated")({
  component: RouteComponent,
  beforeLoad: async () => {
    const accessToken = await authenticate();

    const { userId } = decode(accessToken);
    Sentry.setUser({ id: userId });
    rudderAnalytics.identify(userId);
  },
  loader: ({ context }) => {
    // Prefetch banner placements in background without blocking navigation
    // In future, if there are a lot more slugs to fetch, we can consider fetching multiple slugs in a single request if needed
    Object.values(BannersPlacementSlug).forEach((slug) => {
      context.queryClient.prefetchQuery(bannersPlacementQueryOptions(slug));
    });
  },
  onEnter: () => {
    rudderAnalytics.track(CommonTrackingEvents.USER_OPENED_APP);
  },
});

function RouteComponent() {
  return <Outlet />;
}
